// src/pages/FirewallRules.js
import React, { useState } from 'react';
import Layout from '../components/Layout';
import ComingSoon from '../components/ComingSoon';

function FirewallRules() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <Layout>
            <ComingSoon>
            <div className="p-8">
                <h1 className="text-4xl font-bold text-white mb-8">Firewall Rules</h1>
                <div className="flex justify-between mb-4">
                    <div>
                        <button onClick={openModal} className="bg-custom-gray text-white py-2 px-4 rounded mr-2">
                            Add Application Filter
                        </button>
                        <button onClick={openModal} className="bg-custom-gray text-white py-2 px-4 rounded">
                            Create Rule
                        </button>
                    </div>
                    <div className="relative">
                        <input type="search" className="bg-dark-card text-white py-2 px-4 rounded pl-10" placeholder="Search"/>
                        <div className="absolute top-0 left-0 mt-2 ml-3">
                            <svg className="text-white h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20Zm0-18a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Z"/>
                                <path d="M21.707,20.293l-5.387-5.387a1,1,0,0,0-1.414,1.414l5.387,5.387a1,1,0,0,0,1.414-1.414Z"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="bg-dark-card rounded-lg shadow-md p-4 text-white">
                    <table className="w-full">
                        <thead>
                            <tr className="border-b border-custom-gray">
                                <th className="text-left p-2">Rule Name</th>
                                <th className="text-left p-2">IP Addresses</th>
                                <th className="text-left p-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b border-custom-gray">
                                <td className="p-2">My Rule</td>
                                <td className="p-2">167.94.253.0/24</td>
                                <td className="p-2">
                                    <button onClick={openModal} className="bg-custom-gray hover:bg-black text-white font-bold py-1 px-2 rounded inline-flex items-center">
                                        Manage Rule
                                    </button>
                                </td>
                            </tr>
                            {/* Repeat for each rule */}
                        </tbody>
                    </table>
                </div>
            </div>

                {/* Modal */}
                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                        <div className="bg-dark-card rounded-lg shadow-md p-4 text-white w-full max-w-4xl relative">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-bold">Create Rule</h2>
                                <button onClick={closeModal} className="text-xl leading-none">&times;</button>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <input className="rounded p-2 w-full" style={{ backgroundColor: '#272E3B', color: 'white' }} placeholder="Rule Name *" />
                                <input className="rounded p-2 w-full" style={{ backgroundColor: '#272E3B', color: 'white' }} placeholder="IP Address *" />
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <input className="rounded p-2 w-full" style={{ backgroundColor: '#272E3B', color: 'white' }} placeholder="Source ASN/ISP/IP" />
                                <div>
                                    <select className="rounded p-2 w-full mb-4" style={{ backgroundColor: '#272E3B', color: 'white' }}>
                                        <option>Protocol *</option>
                                        <option>TCP</option>
                                        <option>UDP</option>
                                        {/* Add more protocols as needed */}
                                    </select>
                                    <select className="rounded p-2 w-full" style={{ backgroundColor: '#272E3B', color: 'white' }}>
                                        <option>Rule Type *</option>
                                        <option>Allow</option>
                                        <option>Block</option>
                                        {/* Add more rule types as needed */}
                                    </select>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <input className="rounded p-2 w-full" style={{ backgroundColor: '#272E3B', color: 'white' }} placeholder="Incoming Port" />
                                <input className="rounded p-2 w-full" style={{ backgroundColor: '#272E3B', color: 'white' }} placeholder="Outgoing Port" />
                            </div>
                            <div className="flex justify-between items-center">
                                <button onClick={closeModal} className="font-bold py-2 px-4 rounded transition duration-300 ease-in-out" style={{ backgroundColor: '#0EA5E9', color: 'white' }}>
                                    Save Rule
                                </button>
                                <span className="text-xl font-bold">AI Powered Firewall rule Creator Coming Soon</span>
                            </div>
                        </div>
                    </div>
                )}
                </ComingSoon>
        </Layout>
    );
}

export default FirewallRules;